import { yupBooleanRequired } from "components/Form/validations";

export const pledgeField = {
  name: "agree_to_pledge",
  validation: yupBooleanRequired,
  initialValue: false,
};

export default [pledgeField];
